module.exports = __webpack_public_path__ + "assets/pictograms/subscribe.90b5d804aa2faf4faa54c94ffa3653f9.svg";